module.exports = __webpack_public_path__ + "img/3_004.440c1c14.webp";